<template>
  <div>
    <Button
      v-bind="$attrs"
      :class="[sizeClass, $attrs.class]"
      label="Redeem Code"
      icon="pi pi-ticket"
      @click="open = true"
    />
    <DialogsRedeemCode
      v-model="open"
      @redeemed="onRedeemed"
    />
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'

defineOptions({ inheritAttrs: false })

const props = withDefaults(defineProps<{
  buttonSize?: 'small' | 'normal' | 'large'
}>(), {
  buttonSize: 'normal',
})

const emit = defineEmits<{ (e: 'redeemed', v: { year: string, subkreweId: string }): void }>()

const open = ref(false)

const sizeClass = computed(() => {
  switch (props.buttonSize) {
    case 'small':
      return 'p-button-sm'
    case 'large':
      return 'p-button-lg'
    default:
      return ''
  }
})

function onRedeemed(info: { year: string, subkreweId: string }) {
  emit('redeemed', info)
  // Close the dialog after a successful redeem
  open.value = false
}
</script>
